<template>
  <div class="number-one">
    <h2 class="number-one__title">
      Соленый крекер<br /><span>№1</span> в России*
    </h2>
    <div class="number-one__cards">
      <div class="number-one__cards__card">
        <div class="_in">
          <div class="_icon">
            <img src="../assets/img/number-1/icon-1.svg" alt="" />
          </div>
          <div class="_title">
            выпечено,<br />
            а не обжарено
          </div>
        </div>
      </div>
      <div class="number-one__cards__card">
        <div class="_in">
          <div class="_icon">
            <img src="../assets/img/number-1/icon-2.svg" alt="" />
          </div>
          <div class="_title">неповторимая<br />хрустающая<br />текстура</div>
        </div>
      </div>
      <div class="number-one__cards__card">
        <div class="_in">
          <div class="_icon">
            <img src="../assets/img/number-1/icon-3.svg" alt="" />
          </div>
          <div class="_title">разнообразие<br />вкусов</div>
        </div>
      </div>
    </div>
    <div class="number-one__hint">
      На&nbsp;основании <strong>данных Нильсен RMS</strong> для категории &laquo;Солёное печенье&raquo; за&nbsp;12&nbsp;месяцев, завершившихся 30&nbsp;ноября 2025, в&nbsp;отношении рынка Национальная городская Россия в&nbsp;Российской Федерации, действительно по&nbsp;состоянию на&nbsp;28.01.2026 (Ⓒ OOO &laquo;Нильсен Дэйта Фэктори&raquo;, 2026г.)
    </div>
    <img
      class="number-one__img-left"
      src="../assets/img/number-1/img-left.webp"
      alt=""
    />
    <img
      class="number-one__img-right"
      src="../assets/img/number-1/img-right.webp"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "NumberOne",
}
</script>

<style lang="scss">
.number-one {
  background-color: $color-yellow;
  color: $color-blue;
  padding: 100px 0 125px;
  position: relative;
  overflow: hidden;
  z-index: 15;
  &__title {
    @include title();
    font-size: 10.4rem;
    span {
      font-family: "Arial";
    }
  }
  &__cards {
    max-width: 890px;
    margin: 43px auto 38px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 24px;
    &__card {
      background-color: white;
      border-radius: 32px;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding-top: 19px;
      ._in {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        flex-wrap: wrap;
        gap: 14px;
      }
      ._title {
        min-height: 88px;
        padding-bottom: 19px;
        width: 100%;
        font-family: $font-text;
        font-size: 2rem;
        font-weight: 900;
        text-transform: uppercase;
        text-align: center;
      }
    }
  }
  &__hint {
    font-family: $font-text;
    font-size: 1.2rem;
    max-width: 760px;
    margin: 0 auto;
    position: relative;
    &:before {
      content: "*";
      position: absolute;
      top: 0;
      left: -10px;
    }
    a {
      color: $color-blue;
    }
    strong {
      font-weight: 900;
      border-bottom: 1px solid;
    }
  }
  &__img-left {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 418px;
    z-index: -1;
  }
  &__img-right {
    position: absolute;
    right: 3%;
    top: 0;
    width: 355px;
  }
}
@include respond-to("small") {
  .number-one {
    &__img-left {
      width: 280px;
    }
    &__img-right {
      position: absolute;
      right: 2%;
      top: 10px;
      width: 255px;
    }
    &__title {
      font-size: 8rem;
    }
  }
}
@include respond-to("smartphone-plus") {
  .number-one {
    padding: 96px 47px;
    border-top-left-radius: 48px;
    border-top-right-radius: 48px;
    margin-top: -48px;
    &__title {
      font-size: 4.7rem;
    }
    &__cards {
      grid-template-columns: 1fr;
      margin-top: 33px;
      margin-bottom: 28px;
      &__card {
        min-height: 247px;
      }
    }
    &__img-left,
    &__img-right {
      display: none;
    }
    &__hint {
      font-size: 1.2rem;
      color: #00188a;
      margin: 0 -20px;
      &:before {
        // display: none;
      }
    }
  }
}
</style>
